import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useContext } from 'react';
import cls from 'clsx';
import ConfigProviderContext from '../config-provider/ConfigProviderContext';

var SwiperItem = function SwiperItem(props) {
  var _useContext = useContext(ConfigProviderContext),
      prefixCls = _useContext.prefixCls,
      createNamespace = _useContext.createNamespace;

  var _createNamespace = createNamespace('swiper-item', prefixCls),
      _createNamespace2 = _slicedToArray(_createNamespace, 1),
      bem = _createNamespace2[0];

  return /*#__PURE__*/React.createElement("div", {
    className: cls(props.className, bem()),
    onClick: props.onClick,
    style: props.style
  }, props.children);
};

export default SwiperItem;